import type { SoundClipsLocale } from './en'

export const soundClipsKo = {
  list: {
    title: '사운드 클립',
    loading: '사운드 클립 로딩 중...',
    error: '오류',
    empty: '사운드 클립을 찾을 수 없습니다',
    emptyDescription: '현재 이 PBX에 구성된 사운드 클립이 없습니다.',
    noResults: '결과 없음',
    noResultsDescription: '검색과 일치하는 사운드 클립이 없습니다.',
    columnName: '이름',
    columnFeatureCode: '기능 코드',
    columnUpdated: '업데이트됨',
    columnActions: '작업',
    featureCodeNone: 'N/A',
    createButton: '+ 새 사운드 클립',
    deleteConfirmTitle: '사운드 클립 삭제',
    deleteConfirmMessage:
      '"{{name}}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    deleteConfirmButton: '삭제',
    deleteSuccess: '사운드 클립이 삭제되었습니다.',
    deleteError: '사운드 클립을 삭제하지 못했습니다.',
    searchPlaceholder: '사운드 클립 검색...',
    recordingInfo:
      '전화기에서 *99를 눌러 새 사운드 클립을 녹음하세요. *100–*109를 눌러 기존 클립을 다시 녹음할 수 있습니다.',
    audioLoadError:
      '오디오를 불러올 수 없습니다 — 다시 녹음해야 할 수 있습니다.',
  },
  create: {
    title: '새 사운드 클립',
    nameLabel: '이름',
    namePlaceholder: '사운드 클립 이름 입력',
    featureCodeLabel: '기능 코드',
    featureCodeNone: '없음',
    audioFileLabel: '오디오 파일',
    audioFilePlaceholder:
      'WAV 또는 MP3 파일을 여기에 끌어다 놓거나 클릭하여 찾아보세요',
    audioFileAccepted: 'WAV, MP3 (최대 25MB)',
    cancel: '취소',
    submit: '사운드 클립 업로드',
    creating: '업로드 중...',
    success: '사운드 클립이 생성되었습니다.',
    error: '사운드 클립을 생성하지 못했습니다.',
    nameRequired: '이름은 필수입니다.',
    audioFileRequired: '오디오 파일이 필요합니다.',
  },
  edit: {
    title: '사운드 클립 편집',
    loading: '사운드 클립 로딩 중...',
    notFound: '사운드 클립을 찾을 수 없습니다.',
    backToList: '← 목록으로 돌아가기',
    nameLabel: '이름',
    namePlaceholder: '사운드 클립 이름 입력',
    featureCodeLabel: '기능 코드',
    featureCodeNone: '없음',
    audioFileLabel: '오디오 파일 교체',
    audioFilePlaceholder: '교체할 새 파일을 끌어다 놓거나 클릭하여 찾아보세요',
    audioFileAccepted: 'WAV, MP3 (최대 25MB)',
    currentAudio: '현재 오디오',
    playCurrentAudio: '현재 오디오 재생',
    stopAudio: '정지',
    audioLoadError:
      '이 클립의 오디오를 불러올 수 없습니다 — 다시 녹음해야 할 수 있습니다.',
    createdLabel: '생성됨',
    updatedLabel: '마지막 업데이트',
    cancel: '취소',
    submit: '변경 사항 저장',
    saving: '저장 중...',
    success: '사운드 클립이 업데이트되었습니다.',
    error: '사운드 클립을 업데이트하지 못했습니다.',
    deleteButton: '사운드 클립 삭제',
  },
  upload: {
    invalidType:
      '지원되지 않는 파일 형식입니다. WAV 또는 MP3 파일을 업로드하세요.',
    tooLarge: '파일이 너무 큽니다. 최대 크기는 25MB입니다.',
  },
} satisfies SoundClipsLocale
